/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/button-has-type */
import React,{useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconType, IconSize } from '../icon/icon';
import swal from 'sweetalert';
import { httpPost } from '../../../store/externalCalls/httpCalls';
import calendarIcon from '../../atoms/customIcons/calendarIcon.svg';
import IconCustom from '../iconCustom/iconCustom';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import ModalBootstrap from 'react-bootstrap/Modal';
import { ButtonTheme } from '../button/button';


export const LinkTheme = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
  LIGH: 'ligh',
  DARK: 'dark',
  '': '',
};

export const LinkSize = {
  BLOCK: 'block',
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};


/**
 * Basic link component, it’s designed to edit the href attribute
 */
const ExternalFrame = (props) => {
  const [show,setShow] =useState(false);
  const {
    theme, size, children, className, icon,customIcon, iconColor, iconSize, disabled, value
  } = props;
  const classProps = classNames(
    'btn',
    `btn-${theme}`,
    `btn-${size}`,
    className,
  );
  const handlerOnClick=(e,postUrl,to,enabled)=>{
    setShow(true);
  }
  const handleClose=()=>{
    setShow(false);
  }
  const handleOpenNewTab=()=>{
    window.open(value, '_blank', 'noreferrer');
  }
  
  return (
    <> 
      <a className={theme !== '' ? classProps : ''} style={{"cursor":"pointer"}}
        onClick={(e)=>{handlerOnClick()}}
      >
        {<Icon
          icon={icon}
          iconSize={iconSize}
          iconColor={iconColor}
        />}
   
        {children}
      </a>
      <ModalBootstrap dialogClassName={"modal-popup-iframe"} size={'lg'}
        show={show}
        onHide={handleClose}
        >
        <ModalBootstrap.Header closeButton>
          <ModalBootstrap.Title>
          <>
          <div className="modal-popup-inline">URL preview</div>
          </>
          
          </ModalBootstrap.Title>
        </ModalBootstrap.Header>
        <ModalBootstrap.Body>
          <div style={{"height":"500px","width":"500px"}}>
            <iframe src={value} title="description" style={{"height":"500px","width":"500px"}}></iframe>
          </div>
        </ModalBootstrap.Body>
        <ModalBootstrap.Footer>
          <div>
          <Button
          onClick={handleOpenNewTab}
          theme={ButtonTheme.PRIMARY}
        >
          Open in a new tab
        </Button>
          </div>
        </ModalBootstrap.Footer>
      </ModalBootstrap>
    </>
    );
};

ExternalFrame.propTypes = {
  /**
   * Link background color
   */
  theme: PropTypes.oneOf(Object.values(LinkTheme)),
  /**
   * Link general size
   */
  size: PropTypes.oneOf(Object.values(LinkSize)),
  /**
   * Content to put inside the link component
   */
  children: PropTypes.node,
  /**
   * CSS classes to customize link
   */
  className: PropTypes.string,
  /**
   * To select a icon inside the link
   */
  icon: PropTypes.oneOf(Object.values(IconType)),
  /**
   * Icon color inside the link
   */
  iconColor: PropTypes.string,
  /**
   * Icon size inside the link
   */
  iconSize: PropTypes.oneOf(Object.values(IconSize)),
  /**
   * To disable the link functionality
   */
  disabled: PropTypes.bool,
  /**
   * Link reference
   */
  // to: PropTypes.string.isRequired||PropTypes.number.isRequired,
  to: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
};

ExternalFrame.defaultProps = {
  theme: '',
  size: LinkSize.SMALL,
  children: null,
  className: '',
  icon: '',
  iconColor: '',
  iconSize: IconSize.SMALL,
  disabled: false,
};

export default ExternalFrame;
